export default __webpack_public_path__ + "static/media/nike.93722506.jpg";